<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.table_label_custName') || '客户'"
            prop="custCode"
          >
            <dict-select
              clearable
              v-model="formData.custCode"
              filterable
              url="/master/common/dict/customerSelect"
              style="width:100%"
              :placeholder="$l('INDEX.tips_select_customer') || '请选择客户'"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.order_form_label_endCustCode') || '终端客户'"
          >
            <dict-select
              clearable
              v-model="formData.endCustCode"
              filterable
              url="/master/common/dict/customerSelect"
              style="width:100%"
              :placeholder="$l('INDEX.tips_select_customer') || '请选择客户'"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="
              $l('shipment_customer_setting_needSplitShipment') ||
                '是否需要重新拆分发运记录'
            "
          >
            <br/>
            <el-radio-group v-model="formData.needSplitShipment">
              <el-radio label="Y">{{
                $l('shipment_customer_setting_needSplitShipment_Y') || '需要'
              }}</el-radio>
              <el-radio label="N">{{
                $l('shipment_customer_setting_needSplitShipment_N') || '不需要'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_scaleLength') || '单箱毛净重小数保留位数'"
          >
            <el-select 
              v-model="formData.scaleLength"
              filterable
              clearable
              style="width: 100%"
            >
              <el-option :label="$l('form_label_scaleLength_1') || '保留1位小数'" :value="1"></el-option>
              <el-option :label="$l('form_label_scaleLength_2') || '保留2位小数'" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyTime ? formData.modifyTime : '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  props: {
    shipmentCustomerSettingCode: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
  },
  watch: {},
  mounted() {
    this.getData()
  },
  data() {
    return {
      formData: {needSplitShipment: 'Y', custCode: '', endCustCode: '', scaleLength: 2},
      rules: {
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_customer') || '选择日期',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.shipmentCustomerSettingCode) return
      this.$api
        .shipmentCustomerSettingDetailApi({
          shipmentCustomerSettingCode: this.shipmentCustomerSettingCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }

      this.loadingOpen()
      this.$api
        .shipmentCustomerSettingSaveApi({
          ...this.formData,
        })
        .then((res) => {
          this.loadingClose()
          const {status} = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            if (this.shipmentCustomerSettingCode) {
              this.getData()
            } else {
              this.closeCurPage()
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
